import keycloak from "Keycloak";
import store from "store";

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const userContinent = userTimezone.split("/")[0];
const deviceResolution = window.innerWidth +"X"+ window.innerHeight;

export const requestHeaders = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  'Content-Type': 'application/json',
  // 'Authorization': `Bearer ${store.getState().commonData?.authToken?.token}`,
  //'Content-Encoding': 'gzip',
  //'Accept-Encoding': '*',
  userTimezone,
  userContinent,
  deviceResolution,
};
